;(function() {
  'use strict'

  postsService.$inject = ["$q", "postsResource", "edgeService", "userService", "imageService"];
  angular.module('core.services').service('postsService', postsService)

  // --------------------

  /* @ngInject */
  function postsService(
    $q,
    postsResource,
    edgeService,
    userService,
    imageService
  ) {
    var image

    var extras = [
      { label: 'Feedback', value: 'feedback', icon: 'gi gi-chat' },
      { label: 'Idea', value: 'idea', icon: 'gi gi-idea' },
      { label: 'Complaint', value: 'complaint', icon: 'gi gi-complaint' },
      { label: 'Praise', value: 'praise', icon: 'gi gi-praise' },
      { label: 'Suggestion', value: 'suggestion', icon: 'gi gi-suggestion' },
      { label: 'Request', value: 'request', icon: 'gi gi-request' },
      { label: 'Question', value: 'question', icon: 'gi gi-question' },
    ]

    var types = [
      { label: 'Feedback', value: 'feedback', icon: 'gi-chat' },
      { label: 'Idea', value: 'idea', icon: 'gi-idea' },
      { label: 'Complaint', value: 'complaint', icon: 'gi-complaint' },
      { label: 'Praise', value: 'praise', icon: 'gi-praise' },
      { label: 'Suggestion', value: 'suggestion', icon: 'gi-suggestion' },
      { label: 'Request', value: 'request', icon: 'gi-request' },
      { label: 'Question', value: 'question', icon: 'gi-question' },
    ]

    return {
      list: list,
      // getById: getById,
      create: create,
      comment: comment,
      closePost: closePost,
      markAsRead: markAsRead,
      upvote: upvote,
      downvote: downvote,
      flag: flag,
      unflag: unflag,
      flagComment: flagComment,
      unflagComment: unflagComment,
      moodValues: moodValues,
      getTypes: getTypes,
      npsValues: npsValues,
      holdImage: holdImage,
      getImage: getImage,
    }

    // -----

    function list() {
      return $q(function(resolve, reject) {
        postsResource
          .get({ orderBy: 'updatedAt desc' })
          .success(function(res, data) {
            sort(data)
            addExtras(data)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    // function getById (id, options) {
    //     return $q(function (resolve, reject) {
    //         var data = {
    //             id: id
    //         };
    //         if (options && options.accessToken) {
    //             data.accessToken = options.accessToken;
    //         }
    //         postsResource.get(data).success(function (res, data) {
    //             messageFactory.transform(data);
    //             resolve(data);
    //         }).error(function (data, status) {
    //             reject({
    //                 data: data,
    //                 status: status
    //             });
    //         });
    //     });
    // }

    function create(post, image, options) {
      return $q(function(resolve, reject) {
        if (image) {
          imageService.upload(image).then(createPost)
        } else {
          createPost()
        }

        function createPost(imageUrl) {
          post.imageUrl = imageUrl
          postsResource
            .create(post, null, options)
            .success(function(res, data) {
              resolve(data)
            })
            .error(function(data, status) {
              reject({
                data: data,
                status: status,
              })
            })
        }
      })
    }

    function comment(postId, commentData, accessToken) {
      return $q(function(resolve, reject) {
        var data = {
          id: postId,
          comment: commentData,
        }
        var promise
        if (accessToken) {
          var params = {
            id: postId,
            accessToken: accessToken,
          }
          promise = postsResource.reply(params, data)
        } else {
          promise = postsResource.reply(data)
        }
        promise
          .success(function(res, data) {
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function closePost(postId, exitNps) {
      return $q(function(resolve, reject) {
        var data = {
          id: postId,
          nps: { exit: exitNps },
        }
        postsResource
          .updateState(data)
          .success(function(res, data) {
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function markAsRead(postId) {
      return $q(function(resolve, reject) {
        var data = {
          id: postId,
          state: 'read',
        }
        postsResource
          .updateState(data)
          .success(function(res, data) {
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function flag(postId) {
      return edgeService.create('flag', 'post', postId)
    }

    function unflag(edgeId) {
      return edgeService.remove(edgeId)
    }

    function flagComment(commentId) {
      return edgeService.create('flag', 'comment', commentId)
    }

    function unflagComment(edgeId) {
      return edgeService.remove(edgeId)
    }

    function upvote(postId) {
      return edgeService.create('upvote', 'post', postId)
    }

    function downvote(edgeId) {
      return edgeService.remove(edgeId)
    }

    function moodValues() {
      return [
        { label: 'Happy', value: 'happy', icon: 'gi-happy' },
        { label: 'Ok', value: 'indifferent', icon: 'gi-indifferent' },
        { label: 'Sad', value: 'sad', icon: 'gi-sad' },
      ]
    }

    function getTypes() {
      return _.clone(types)
    }

    function npsValues() {
      return [
        { label: 'Definitely!', value: 5 },
        { label: 'Probably', value: 4 },
        { label: 'Maybe', value: 3 },
        { label: 'No', value: 2 },
        { label: 'Never', value: 1 },
      ]
    }

    function addExtras(posts) {
      _.each(posts, function(post) {
        var found = _.find(extras, { value: post.type })
        post.extras = _.clone(found || {})
        post.extras.isUnread = post.state === 'unread'
        post.extras.isClosed = post.state === 'closed'
        post.extras.isCreator = post.creator.id === (userService.get() || {}).id
        // comment count
        var count = post.counts.comments ? post.counts.comments - 1 : 0
        var pluralizer = post.counts.comments !== 1 ? 's' : ''
        post.extras.commentCount = count + ' Comment' + pluralizer
      })
    }

    function sort(posts) {
      var unread = []
      var read = []
      var closed = []
      // split into unread/read/closed
      _.each(posts, function(post) {
        if (post.state === 'closed') {
          closed.push(post)
        } else if (post.state === 'unread') {
          unread.push(post)
        } else {
          read.push(post)
        }
      })
      // sort them
      unread = _.sortBy(unread, sortFn).reverse()
      read = _.sortBy(read, sortFn).reverse()
      closed = _.sortBy(closed, sortFn).reverse()
      // limit closed to 10
      closed = closed.slice(0, 10)

      function sortFn(post) {
        return moment(post.updatedAt).unix() || 0
      }
      // empty
      posts.splice(0, posts.length)
      // re-fill
      var all = unread.concat(read).concat(closed)
      posts.push.apply(posts, all)
    }

    function holdImage(data) {
      image = data
    }

    function getImage() {
      var data = image
      image = undefined
      return data
    }
  }
})()
